<template>
<div class="goods" v-if="goodinfo">
    <headerNav title="商品详情" />
    <van-swipe class="goods-swipe" :autoplay="3000">
        <van-swipe-item v-for="(thumb,index) in goodinfo.productdto.productImages" :key="index">
            <img :src="$baseurl+thumb.path">
        </van-swipe-item>
    </van-swipe>

    <div style="position:relative;padding:10px 16px;background-color:#fff">
        <div style="padding-right:80px;">
            <span class="goods-price"><span style="font-size:14px">{{goodinfo.productdto.isIntegral?'积分':'¥'}}</span>{{ price||goodinfo.productdto.userPrice+"元"+"/"+goodinfo.productdto.unit}}</span>
            <span class="goods-market-price" v-if="!goodinfo.productdto.isIntegral">¥{{ goodinfo.productdto.price }}</span>
            <div class="goods-title">{{ goodinfo.productdto.pName }}<span v-if="goodinfo.productdto.isSeaProduct" :style="{color:$abctheme.basecolor}">【海外产品】</span></div>
            <div v-if="goodinfo.comment" style="color:red;font-size:14px">半价购买不能和其他商品混合下单</div>
        </div>
        <div style="position:absolute;right:30px;top:20px;" @click="showpic" v-if="abp.userInfo&&!abp.userInfo.memberLevelModel.isRetail&&abp.userInfo.isFirstRecharge">
            <van-icon
              class="main-list-icon-right"
              :size="35"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="fenxiang1"
            />
        </div>
    </div>

    <van-cell   class="goods-tag" v-if="goodinfo.productdto.isSeaProduct" >
        <template slot="title" style="font-size:10px;">
            <van-icon
              class="um-btns-btn-icon"
              :size="14"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="quanqiu"
            />
            <span >全球发货</span>
            <van-icon
              class="um-btns-btn-icon"
              :size="14"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="icon"
            />
            <span >监管保税仓</span>
            <van-icon
              class="um-btns-btn-icon"
              :size="14"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="danju"
            />
            <span >用户下单</span>
            <van-icon
              class="um-btns-btn-icon"
              :size="14"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="haiguan"
            />
            <span >报关清关</span>
            <van-icon
              class="um-btns-btn-icon"
              :size="14"
              :color="$abctheme.basecolor"
              class-prefix="abc-icon"
              name="yifahuo"
            />
            <span>国内快递</span>
        </template>
      </van-cell>   

    <van-cell-group class="goods-cell-group" v-if="goodinfo.couponList && goodinfo.couponList.length>0">
      <van-cell is-link  @click="showPromotion" >
        <template slot="title">
            <span style="margin-right: 10px;">领券</span>
            <van-tag type="danger" v-for="item in goodinfo.couponList" :key="item.id" mark  style="margin-right: 5px;">
                <span v-if="item.minSellPrice==0">
                    无门槛减{{item.price}}元
                </span>
                <span v-else>满{{item.minSellPrice}}减{{item.price}}</span>
            </van-tag>
        </template>
      </van-cell>
      
      <!-- <van-cell  is-link @click="showPromotion" >
        <template slot="title">
            <span style="margin-right: 10px;">促销</span>
            <van-tag type="danger" style="margin-right: 5px;">多买优惠</van-tag>
            <van-tag type="danger" style="margin-right: 5px;">满减</van-tag>
            <van-tag type="danger" style="margin-right: 5px;">限购</van-tag>
        </template>
      </van-cell> -->
    </van-cell-group>

    <van-cell-group class="goods-cell-group">
          <van-cell v-if="!goodinfo.productdto.isBuy">
            <div slot="title" style="color:#f44">预售开始时间：{{goodinfo.productdto.preSaleTime}}</div>
        </van-cell>
        <van-cell is-link @click="showSku" v-if="goodinfo.productdto.isBuy">
            <template slot="title">
                <div v-if="goodinfo.productdto.ismoresku">
                    <div v-if="initialSku">
                        <span>{{selecttext==""?"请选择":selecttext}}</span>
                    </div>
                </div>
                <div v-else>
                    <span style="margin-right: 10px;">已选</span>
                    <span>无规格</span>
                </div>
            </template>
        </van-cell>
        <van-cell is-link @click="levpriceshow=true" v-if="goodinfo.productLevel && goodinfo.productLevel.length">
            <template slot="title">
                <div>
                    <div>
                        <span>查看各等级拿货价</span>
                    </div>
                </div>
                
            </template>
        </van-cell>
    </van-cell-group>

    <div class="goods-info">
        <p class="goods-info-title">图文详情</p>
        <div class="good-info-fwb" v-html="goodinfo.productdto.description"></div>
    </div>
    <van-goods-action v-if="goodinfo.productdto.isBuy">

        <!-- <van-goods-action-icon icon="star" text="收藏" color="#ff5000" @click="sorry" /> -->

        <van-goods-action-icon icon="cart-o" text="购物车" @click="onClickCart" />
        <van-goods-action-button type="warning" text="加入购物车" @click="showSku" />
        <van-goods-action-button type="danger" text="立即购买" @click="showSku" />
    </van-goods-action>
    <!-- <van-action-sheet v-model="show" title="促销" style="font-size:14px;">
        
            <van-cell  is-link @click="sorry" >
                <template slot="title">
                    <van-tag type="danger">多买优惠</van-tag>
                    <span> 满2件，总价打9折</span>
                </template>
            </van-cell>
            <van-cell  is-link @click="sorry" >
                <template slot="title">
                    <van-tag type="danger">满减</van-tag>
                    <span> 满100元减50元</span>
                </template>
            </van-cell>
            <van-cell  is-link @click="sorry" >
                <template slot="title">
                    <van-tag type="danger">限购</van-tag>
                    <span> 购买不超过5件时享受单件价￥8.00，超出数量以结算价为准</span>
                </template>
            </van-cell>
    </van-action-sheet> -->

    <!-- <van-action-sheet v-model="showTag" title="服务说明" style="font-size:14px;">
        
            <van-cell>
                <template slot="title">
                    <van-icon name="passed" color="red" style="margin-right: 10px;" />
                    <span >次日达</span>
                    <div style="margin-left: 24px;font-size:10px;color:#7d7d7d;">指定时间前下单，次日送达</div>
                </template>
            </van-cell>
            <van-cell>
                <template slot="title">
                    <van-icon name="passed" color="red" style="margin-right: 10px;" />
                    <span >自提</span>
                    <div style="margin-left: 24px;font-size:10px;color:#7d7d7d;">我们提供多种自提服务，包括自提点、自助提货柜、移动自提车等服务</div>
                </template>
            </van-cell>
            <van-cell>
                <template slot="title">
                    <van-icon name="passed" color="red" style="margin-right: 10px;" />
                    <span >闪电退款</span>
                    <div style="margin-left: 24px;font-size:10px;color:#7d7d7d;">签收7天内退货的，提供先退款后退货服务。</div>
                </template>
            </van-cell>
            <van-cell>
                <template slot="title">
                    <van-icon name="passed" color="red" style="margin-right: 10px;" />
                    <span >七天无理由退货（拆封后不支持）</span>
                    <div style="margin-left: 24px;font-size:10px;color:#7d7d7d;">七天无理由退货（拆封后不支持）</div>
                </template>
            </van-cell>
            <van-cell>
                <template slot="title">
                    <van-icon name="passed" color="red" style="margin-right: 10px;" />
                    <span >前海保税仓</span>
                    <div style="margin-left: 24px;font-size:10px;color:#7d7d7d;">本商品由前海保税仓发货</div>
                </template>
            </van-cell>
    </van-action-sheet> -->

    <van-sku v-model="showBase" ref="vansku" :sku="goodinfo.productdto.vantSku" :goods="goodinfo.productdto.goods" :goods-id="goodinfo.productdto.productSku" :hide-stock="goodinfo.productdto.hideStock" :quota="goodinfo.productdto.quota" :quota-used="goodinfo.productdto.quotaused" :close-on-click-overlay="closeOnClickOverlay" :properties="goodinfo.productdto.vantProperties" :initial-sku="initialSku" @sku-selected="skuselect" @buy-clicked="onBuyClicked" @add-cart="onAddCartClicked" @sku-prop-selected="propertyselect">
         <template #sku-header-price="props">
    <div class="van-sku__goods-price">
      <span class="van-sku__price-symbol">{{goodinfo.productdto.isIntegral?'积分':'¥'}}</span
      ><span class="van-sku__price-num">{{ props.price }}</span>
    </div>
  </template>
    </van-sku>

     <van-dialog
      :show-confirm-button="false"
      :show-cancel-button="false"
      closeOnClickOverlay
      v-model="showfenxiangtu"
      title=""
      width="360px"
    >
      <img style="width: 350px; height: atuo" :src="$baseurl + showfenxiangtuQrcode" />
    </van-dialog>
   
   <van-popup v-model="levpriceshow" position="bottom" :style="{ height: '30%' }" >
       <van-cell-group>
  <van-cell  v-for="item in goodinfo.productLevel" :key="item.level" :title="item.levelName" :value="'￥'+item.price+'元'" />
 
</van-cell-group>
      
   </van-popup>
</div>
</template>

<script>
import skuData from '../../data/sku';
import request from "../../config/ajax";
import Util from "../../config/Util";
export default {
    components: {},
    data() {
        this.skuData = skuData;
        return {
            showfenxiangtu:false,
            showfenxiangtuQrcode:'',
            showBase: false,
            closeOnClickOverlay: true,
            productParams: {
                productSku: '',
            },
            goodinfo: undefined,
            initialSku: {

            },
            selecttext: "",
            price: 0,
            addcartparams: {
                sku: '',
                quantity: 1,
                cartonSize: undefined
            },
            seamsg:'海外产品产品需要个人身份证信息,请先填写身份证信息',
            cursku:'',
            levpriceshow:false
        };
    },
    created() {
        //获取路由sku
        var sku = this.$router.currentRoute.params.id;
        this.productParams.productSku = sku;
        this.cursku=sku;
        //获取产品信息
        request.post("/api/services/app/PhoneCom/QueryVantInfo", this.productParams).then(x => {
            this.goodinfo = x.result;
        });
    },
    methods: {
        formatPrice(data) {
            return '¥' + (data / 100).toFixed(2);
        },
        onClickCart() {
            if (this.abp.userInfo.memberLevelModel.isRetail) {

                this.$router.push('/retailcart');
            } else {

                this.$router.push('/cart');
            }

        },
        getcurprice() {
            if (this.goodinfo.secdto != null && this.cursec != null) {
                this.curprice = this.formatPrice(this.cursec.secPrice);
            } else {
                this.curprice = this.formatPrice(this.curspec.price * this.discount);
            }

            //console.log(this.curprice);
        },
        sorry() {
            this.$toast('暂无后续逻辑~');
        },
        showPromotion() {
            this.show = true;
            let couponids=this.goodinfo.couponList.map(x=>{
                return x.id;
            });
            localStorage.setItem('couponids',couponids)
            this.$router.push({
                    path: "/user/coupon/available"
                });
        },
        showSku() {
            //console.log(this.$refs.vansku);
            this.showBase = true;
        },
        onClickShowTag() {
            this.showTag = true;
        },
        showpic()
        {
            if(!this.showfenxiangtuQrcode)
            {
                this.ajax.post("/api/services/app/PhoneUser/ProductFenXiangImg?sku="+this.cursku).then((x) => {
                    this.showfenxiangtuQrcode = x.result;
                    this.showfenxiangtu = true;
                });
            }
            else
            {
                this.showfenxiangtu = true;
            }
            
        },
        onBuyClicked(data) {
            //console.log(this.initialSku);
            //console.log("购买打印日志:",data);
            //this.$toast(JSON.stringify(data));
            //console.log(JSON.stringify(data));
            if (!Util.abp.session.userId) {
                this.$router.push({
                    path: "/login/password"
                });
                return;
            }


            var sku = data.selectedSkuComb.id;
            var num = data.selectedNum;
            if (this.goodinfo.productdto.minSellNum > 0) {
                if (num < this.goodinfo.productdto.minSellNum) {
                    this.$toast.fail('该商品起购数量为:' + this.goodinfo.productdto.minSellNum)
                    return;
                }
            }
            var cartonsize = undefined;
            if (data.selectedSkuComb.properties != undefined && data.selectedSkuComb.properties.length > 0) {
                cartonsize = data.selectedSkuComb.properties[0].v[0].id;
            }
            let gooddetail = this.goodinfo.productdto.specInfo.filter(x => x.sku == sku)[0];

            let goodmodel = {
                productInfo: this.goodinfo.productdto,
                isServer: this.goodinfo.productdto.isServer,
                productSpec: gooddetail,
                quantity: num,
                sku: sku,
                title: this.goodinfo.productdto.pName,
                desc: gooddetail.specName,
                price: this.price || this.goodinfo.productdto.userPrice,
                imageURL:gooddetail.specImg || this.goodinfo.productdto.productImageUrl,
                cartonSize: cartonsize,
                unit: this.goodinfo.productdto.unit,
                isSeaProduct:this.goodinfo.productdto.isSeaProduct
            };
            let goodlist = [];
            goodlist.push(goodmodel);

            //判断库存是否充足  才进入订单创建页面
            let list = goodlist.map(x => {
                x.num = x.quantity
                return x;
            })

            request.post('/api/services/app/PhoneTrade/IsBuy', {
                list: list
            }).then(() => {
                let param={
                            createType: 1
                        };
                //获取当前活动Id
                if(this.goodinfo.secdto!=null)
                {
                    param.secid=this.goodinfo.secdto.id;
                    this.goodinfo.secdto.details.forEach(p => {
						if (p.productSpec.sku == sku) {
							param.secdetailid = p.id;
						}
					})
                    
                	//curl+="&secid="+this.secdto.id+"&secdetailid="+this.cursec.id;
                }
                console.log(param)
                console.log(goodlist);
                localStorage.setItem("createorderinfo", JSON.stringify(goodlist));

                if (this.abp.userInfo.memberLevelModel.isRetail) {
                    this.$router.push({
                        name: 'retailship',
                        params: param
                    });
                } else {
                    this.$router.push({
                        name: 'order',
                        params: param
                    });
                }
            })
        },
        onAddCartClicked(data) {
            //console.log("加入购物车:",data);
            //this.$toast(JSON.stringify(data));
            console.log(data);
            if (!Util.abp.session.userId) {
                this.$router.push({
                    path: "/login/password"
                });
                return;
            }

            var sku = data.selectedSkuComb.id;
            var num = data.selectedNum;
            var cartonsize = undefined;
            if (data.selectedSkuComb.properties != undefined && data.selectedSkuComb.properties.length > 0) {
                cartonsize = data.selectedSkuComb.properties[0].v[0].id;
            }
            this.addcartparams.sku = sku;
            this.addcartparams.quantity = num;
            this.addcartparams.cartonSize = cartonsize;
            request.post('/api/services/app/PhoneCart/Create', this.addcartparams).then(() => {
                this.$toast('加入成功');
                this.showBase = false;
            })

            // request.post('/api/services/app/PhoneTrade/IsBuy', {
            //   list: [{
            //     sku: sku,
            //     num: num
            //   }],
            // }).then(() => {
            //   this.addcartparams.sku=sku;
            //   this.addcartparams.quantity=num;
            //   request.post('/api/services/app/PhoneCart/Create', this.addcartparams).then(() => {
            //     this.$toast('加入成功');
            //     this.showBase=false;
            //   })
            // })

        },
        skuselect() {

            this.selecttext = this.$refs.vansku.selectedText;
            if (this.$refs.vansku.price) {

                this.price = this.$refs.vansku.price;
            } else {
                this.price = this.goodinfo.productdto.userPrice;
            }
            //console.log(this.$refs.vansku);
            //console.log(item);
        },
        propertyselect() {
            this.selecttext = this.$refs.vansku.selectedText;
            if (this.$refs.vansku.price) {

                this.price = this.$refs.vansku.price;
            } else {
                this.price = this.goodinfo.productdto.userPrice;
            }
        }

    }

}
</script>

<style lang="scss" scoped>
.goods {
    padding-bottom: 50px;
}

.goods-swipe img {
    width: 7.5rem;
    height: 7.5rem;
    display: block;
}

.goods-tag {
    font-size: 12px;
    border-top: 1px solid #e5e5e5;
}

.goods-tag span {
    margin-right: 10px;
}

.goods-tag i {
    color: red;
    margin-right: 3px;
}

.goods-tag img {
    width: 12px;
    margin-right: 3px;
    margin-top: 6px;
}

.goods-title {
    line-height: 18px;
    padding-top: 10px;
    margin-bottom: 6px;
    font-size: 14px;
    color: #333;
    font-weight: 700;
    word-break:break-all;
}

.goods-subtit {
    font-size: 13px;
    color: #333;
    line-height: 21px;
}

.goods-price {
    color: #f44;
    font-size: 20px;
}

.goods-market-price {
    text-decoration: line-through;
    margin-left: 8px;
    font-size: 13px;
    color: #999;
}

.goods-cell-group {
    margin: 15px 0;

}

.goods-cell-group .van-cell__value {
    color: #999;
}

.goods-info {
    background-color: #fff;
}

.goods-info-title {
    height: 44px;
    line-height: 44px;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    margin: 10px;
    border-top: 1px solid #e5e5e5;
}

.goods-info p {
    margin: 0;
    padding: 0;
    margin-block-end: 0;
    margin-block-start: 0;
    display: grid;
}

.goods-swipe img {
    width: 100%;
    height: auto;
}
</style>
<style lang="scss" scoped>
// .good-info-fwb img {
//     width: 100%;
// }
</style>
